import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

// ios 只能打开APP设置首页
// android 不传参时打开APP设置首页，type=permission时打开权限设置页，type=location时打开定位权限设置页（无论是否已开启定位权限）
// android 可另外支持直接指定打开更多的权限设置页（无线和网络设置界面、wlan界面（wifi热点列表)、移动网络设置界面、权限设置界面、系统设置界面、安全和隐私设置界面、日期和时间设置、显示设置、语言和地区设置、定位服务设置(已经安装的应用程序访问我的位置信息)、声音设置界面、蓝牙开关界面、NFC 共享设置、NFC 设置打开或关闭、存储信息）
// android 并非所有的设备都能直接打开具体的权限设置页，不支持时只能打开设置首页
export type FabricUtilsOpenAppSettingsOptions =
  | { type: 'permission' | 'location' }
  | undefined;

export type FabricUtilsOpenAppSettingsApi = (
  options?: FabricUtilsOpenAppSettingsOptions
) => Promise<boolean>;

/**
 * 打开Native设置里面对应的应用设置面板
 */
export const openAppSettings: FabricUtilsOpenAppSettingsApi = (
  options?: FabricUtilsOpenAppSettingsOptions
) => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<
      'fabric_utils.openAppSettings',
      FabricUtilsOpenAppSettingsOptions,
      boolean
    >('fabric_utils.openAppSettings', options, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
